package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2025_03_01_Day_2() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Brauna informs the heroes that Master Danvid has scheduled a 9am meeting at the Malusian compound. At the meeting are:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Lady Soren Aventary of the Peers")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Master Danvid of the Powerglow guild")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Voth Gardul, Commander of the City Guard")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Sir Sorlon Dragstone (a high level officer in the Malusian Calvary & Goram’s father)")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("They tell the heroes that Do’shara was the primary blue dragon on the continent. She was very ancient, and they are surprised that the heroes survived an encounter with her. They conclude that Do’shara was aligned with the demon Graz’zt. Do’shara does have offspring. Sylus (the green dragon) has not been seen in Malus since the heroes left the city. Tuesday tells the Malusians that the heroes murdered a bunch of Duke of Brij guards on their way to find Do’shara on the second floor of the Thardos family ruins. The heroes report their findings on aggressive and huge scorpions in the desert, but the Malusians have already heard this report from Joral Deetry. Sorlon says his infantry will secure the route to and the area around Well’s Bounty; he acknowledges that his forces have been delayed at Brij. The leadership tell the heroes that Gram DeLoren is Chancellor of Brij and rules when the Duke is away. He started in this position about one year ago. The heroes point out that this would be after the real Duke of Brij had died, so he may have been appointed to this position by Do’shara.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The discussion moves to next steps for the heroes.")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Elrovir Rodiridan did teleport to Furro and has arrived in the area near one of the scried shards, but he hasn’t made much progress towards finding it yet.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("The Dorvidians appear to be preparing for war. The Dorvidian military destroyed the guild’s teleportation circle in Dorvid, the Dorvdian capital city.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Bondōvriar has a teleportation circle.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("The summer festival begins in about two weeks, celebrating the end of spring and the start of summer.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The group decides to pursue the shard near Seshiss by way of the Bondōvriar teleportation circle tomorrow.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Most of the group heads to market while Goram stays behind to speak with his father. Caper tells a livestock vender named Patch that she needs a cow for the swamp. The vender tells Caper to meet him near the temple to Entor where his livestock are stationed. The heroes visit the temple to Entor, and Caper shares their story about receiving the blessing of Entor at the Thardos family ruins. Brother Zelenus records the story as Caper tells it. The heroes move on to “Patch’s Paddocks.” Tuesday speaks to the prospective marsh cow and learns that it is called “Asta.” Caper feeds Asta a prickly pear, compliments it, and shows it affection. Patch isn’t sure what to make of this situation but says that the cow costs 10 gold. Caper pays 20 gold. She names the cow Aloysius.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Falorn wants to spend the night at the Gleaming Horde rather than the tower, so the heroes head over there and sit down for some food and drink. While the heroes are enjoying themselves, Goram arrives and has a stern look on his face.")
    }
}
